import React, { Fragment } from 'react'
import { links } from 'common/helpers'

import Link from 'components/ui/Link/Link'
import Picture from 'components/ui/Picture/Picture'

import messages from './messages'
import s from './FooterSocials.scss'

import instagramIcon from './images/instagram.svg'
import facebookIcon from './images/facebook.svg'
import twitterIcon from './images/twitter.svg'
import pinterestIcon from './images/pinterest.svg'


const socials = [
  {
    image: instagramIcon,
    link: 'https://instagram.com/scentbird/',
    name: 'Instagram',
    ariaLabel: 'Instagram',
  },
  {
    image: facebookIcon,
    link: 'https://www.facebook.com/scentbird',
    name: 'Facebook',
    ariaLabel: 'Facebook',
  },
  {
    image: twitterIcon,
    link: 'https://www.twitter.com/scentbird',
    name: 'Twitter',
    ariaLabel: 'Twitter',
  },
  {
    image: pinterestIcon,
    link: 'https://www.pinterest.com/scentbird/',
    name: 'Pinterest',
    ariaLabel: 'Pinterest',
  },
]

const FooterSocials = () => (
  <Fragment>
    <div className={s.socials}>
      {
        socials.map(({ image, link, name, ariaLabel }, index) => (
          <a
            key={index}
            className={s.social}
            href={link}
            rel="noopener noreferrer nofollow"
            aria-label={ariaLabel}
            target="_blank"
          >
            <Picture src={image} alt={name} />
          </a>
        ))
      }
    </div>
    <div className={s.bottomLinks}>
      <Link className={s.bottomLink} href={links.privacy} title={messages.privacyPolicy} customColor />
      <Link className={s.bottomLink} href={links.terms} title={messages.terms} customColor />
    </div>
  </Fragment>
)


export default FooterSocials
